const SYLLABLE_POOL: Record<number, string[]> = {
  2: [
    "БА",
    "БО",
    "БУ",
    "БЫ",
    "БЕ",

    "ВА",
    "ВО",
    "ВУ",
    "ВЫ",
    "ВЕ",

    "ГА",
    "ГО",
    "ГУ",
    "ГЫ",
    "ГЕ",

    "ДА",
    "ДО",
    "ДУ",
    "ДЫ",
    "ДЕ",

    "ЖА",
    "ЖО",
    "ЖУ",
    "ЖЫ",
    "ЖЕ",

    "ЗА",
    "ЗО",
    "ЗУ",
    "ЗЫ",
    "ЗЕ",

    "КА",
    "КО",
    "КУ",
    "КЫ",
    "КЕ",

    "ЛА",
    "ЛО",
    "ЛУ",
    "ЛЫ",
    "ЛЕ",

    "МА",
    "МО",
    "МУ",
    "МЫ",
    "МЕ",

    "НА",
    "НО",
    "НУ",
    "НЫ",
    "НЕ",

    "ПА",
    "ПО",
    "ПУ",
    "ПЫ",
    "ПЕ",

    "РА",
    "РО",
    "РУ",
    "РЫ",
    "РЕ",

    "СА",
    "СО",
    "СУ",
    "СЫ",
    "СЕ",

    "ТА",
    "ТО",
    "ТУ",
    "ТЫ",
    "ТЕ",

    "ФА",
    "ФО",
    "ФУ",
    "ФЫ",
    "ФЕ",

    "ХА",
    "ХО",
    "ХУ",
    "ХЫ",
    "ХЕ",

    "ЦА",
    "ЦО",
    "ЦУ",
    "ЦЫ",
    "ЦЕ",

    "ЧА",
    "ЧО",
    "ЧУ",
    "ЧЕ",

    "ША",
    "ШО",
    "ШУ",
    "ШИ",

    "ЩА",
    "ЩО",
    "ЩУ",
    "ЩЕ",
  ],
  3: [
    "БАК",
    "БОК",
    "БУК",
    "БЫК",
    "ВАЛ",
    "ВОЛ",
    "ВУЛ",
    "ВЫЛ",
    "ГАД",
    "ГОД",
    "ГУД",
    "ДАР",
    "ДОМ",
    "ДУБ",
    "ДЫМ",
    "ЖАР",
    "ЖИР",
    "ЗАЛ",
    "ЗОВ",
    "ЗУБ",
    "КАР",
    "КОТ",
    "КУМ",
    "КЫШ",
    "ЛАК",
    "ЛЕС",
    "ЛОМ",
    "ЛУН",
    "ЛЫЖ",
    "МАК",
    "МЕЛ",
    "МИР",
    "МОР",
    "МУХ",
    "НАС",
    "НОС",
    "НУР",
    "ПАР",
    "ПЕС",
    "ПИР",
    "ПОЛ",
    "ПУХ",
    "РАК",
    "РЕЗ",
    "РОГ",
    "РУБ",
    "РЫБ",
    "САД",
    "СЕД",
    "СИР",
    "СОН",
    "СУК",
    "ТАК",
    "ТЕМ",
    "ТИР",
    "ТОК",
    "ТУР",
    "ФАР",
    "ФИН",
    "ФОР",
    "ФУР",
    "ХАМ",
    "ХИТ",
    "ХОР",
    "ХУН",
    "ЦАР",
    "ЦЕХ",
    "ЦИК",
    "ЧАС",
    "ЧЕК",
    "ЧИН",
    "ЧУМ",
    "ШАР",
    "ШЕФ",
    "ШИК",
    "ШОК",
    "ШУМ",
    "ЩЕП",
    "ЩУР",
  ],
  4: [
    "БЛИН",
    "БЛОК",
    "БЛЮЗ",
    "ГРАД",
    "ГРИБ",
    "ГРОМ",
    "ГРУД",
    "ДВОР",
    "ДРУГ",
    "ЗВОН",
    "ЗНАК",
    "КЛАД",
    "КЛИН",
    "КЛУБ",
    "КРАБ",
    "КРАН",
    "КРИК",
    "КРОТ",
    "КРУГ",
    "ЛИСТ",
    "МОСТ",
    "ПАРК",
    "ПЛАН",
    "ПЛЕД",
    "ПЛОД",
    "ПРУД",
    "РОСТ",
    "СЛЕД",
    "СЛОН",
    "СМЕХ",
    "СНЕГ",
    "СТОЛ",
    "СТУЛ",
    "ТОРТ",
    "ТРУД",
    "ЦВЕТ",
    "ШПОН",
  ],
};

export default function createTableType1(
  words: string[],
  size: [number, number],
): string[][] {
  const [rows, columns] = size;
  const cellCount = rows * columns;

  const syllables = Array.from(
    new Set(words.flatMap((word) => word.split("|"))),
  );

  const usedSyllables = new Set(syllables);
  const maxLength = Math.max(...syllables.map((s) => s.length));

  const randomPool = Object.entries(SYLLABLE_POOL)
    .filter(([length]) => Number(length) <= maxLength)
    .flatMap(([, value]) => value)
    .filter((syllable) => !usedSyllables.has(syllable));

  const result = [...syllables];

  while (result.length < cellCount) {
    if (randomPool.length === 0) {
      throw new Error(
        "Недостаточно уникальных случайных слогов для заполнения таблицы",
      );
    }

    const randomIndex = Math.floor(Math.random() * randomPool.length);

    const randomSyllable = randomPool[randomIndex];

    result.push(randomSyllable);

    randomPool.splice(randomIndex, 1);
  }

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  const table: string[][] = [];

  for (let i = 0; i < rows; i++) {
    table.push(result.slice(i * columns, (i + 1) * columns));
  }

  return table;
}
